<template>
  <div>
    <el-table :data="tableData" height="300px" highlight-current-row style="width: 100%">
      <el-table-column property="value" :label="skcSpec.name" width="100">
        <template slot="header"> <span style="color: red">*</span>{{ skcSpec.name }} </template>
      </el-table-column>
      <el-table-column property="previewImgUrls">
        <template slot="header"> <span style="color: red">*</span> 轮播图(5-10张，宽高比例为3:4，宽>1340px，高>1785px，小于2M) </template>
        <template slot-scope="{ row, $index }">
          <CarouselImages
            :ref="`carouselImagesRef_${$index}`"
            v-model="row.previewImgUrls"
            :languages="languages"
            :languageMap="languageMap"
            :imgLimits="carouselImagesLimits"
          />
        </template>
      </el-table-column>
      <!-- <el-table-column property="simg" label="色块图" width="120">
        <template slot-scope="{ row }">
          <MutiImgUpload :ref="`simg_${lang}`" v-model="row.simg" :mainImgNums="0" :limitNums="1" />
        </template>
      </el-table-column> -->
      <el-table-column property="extCode" label="货号" width="150">
        <template slot-scope="{ row }">
          <el-input v-model="row.extCode"></el-input>
        </template>
      </el-table-column>
      <!-- <el-table-column property="" label="操作" width="100">
        <template slot-scope="{ row }">
          <el-link type="danger">删除</el-link>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="tips">因平台接口限制，此表格不支持BOM单录入，如有需要请到TEMU商家后台完善BOM单</div>
  </div>
</template>
  
<script>
import CarouselImages from '../../TemuInfoForm/components/CarouselImages.vue';

import { LANGUAGE_MAP } from '@/dictionary/i18n.js'
import { cloneDeep, isEmpty } from 'lodash';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
export default {
  name: 'SkcCarouselImageList',
  components: { CarouselImages,MutiImgUpload },
  props: {
    languages:{
      type:Array,
      default(){
        return ['en']
      }
    },
    skcSpec: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      languageMap:LANGUAGE_MAP,
      tableData: [],
      carouselImagesLimits: {
        limitSize: 2 * 1024 * 1024,
        limitHeight: [1785, 0],
        limitWidth: [1340, 0],
        limitNums: 10,
        aspectRatio: [0.75],
        aspectRatioText: '3:4',
        cropDefaultSize: [1500, 2000],
        imgNames: [],
        isChange: false,
      },
    };
  },
  watch: {
    skcSpec: {
      handler(v, oldV) {
        if (isEmpty(v)) return;
        if (this.isChange) {
          this.isChange = false;
          return;
        }
        this.tableData = v.values.map(specV => {
          const previewImgUrls = specV.extendValues?.product_skc?.previewImgUrls || [];
          return {
            value: specV.value,
            previewImgUrls,
            extCode: specV.extendValues?.product_skc?.extCode || '',
          };
        });
      },
      immediate: true,
      deep: true,
    },
    tableData: {
      handler(v, oldV) {
        this.$emit('change', cloneDeep(this.tableData));
        this.isChange = true;
      },
      deep: true,
    },
  },
  methods: {
    async validate() {
      if (!this.tableData.length) {
        return true;
      }
      try {
        const results = await Promise.all(
          this.tableData.map(async (row, index) => {
            const ref = this.$refs[`carouselImagesRef_${index}`];
            // 兼容 validate 返回 Promise 或同步值
            const valid = ref && typeof ref.validate === 'function' ? await ref.validate() : true;
            return Promise.resolve(valid);
          })
        );
        return results.every(result => result);
      } catch (e) {
        console.log('validate has Error', e);
        return false;
      }
    },
  },
};
</script>
  
<style lang="scss">
.input-number {
  .el-input__inner {
    text-align: left;
  }
}
.tips{
  font-size: 12px;
  color: #909399;
}
</style>